import { createAsyncThunk } from "@reduxjs/toolkit";
import API_ROUTES from "../../../constants/apiRoutes";
import { authApi } from "../../../constants/reduxConstant";
import { getAuthorization } from "../../../services/config";
import { updateLoading } from "../loader";
import { ToastNotifyError } from "../../../components/CommonComponents/Toast/ToastNotify";
import rollbar from "../../../rollbarConfig";

const {
  login = "",
  logout = "",
  forget_password = "",
  signup = "",
  get_citys = "",
  email_check = "",
  get_countrys = "",
  get_citys_by_country = ""
} = authApi;
const { V1: {
  LOGIN,
  LOGOUT,
  FORGET_PASSWORD,
  RESET_LINK_CHECK,
  SIGNUP, GET_CITYS,
  PRE_SIGNED_URL,
  CHECK_EMAIL,
  STATUS_SELLER_COLOR,
  TERMS_AND_CONDITION,
  PRIVACY_POLICY,
  CUSTOMER_SUPPORT,
  RESET_PASSWORD,
  GET_COUNTRYS,
  GET_CITYS_BY_COUNTRY,
  FAQ,
  NEWSLETTER
} = {} } = API_ROUTES;

const fetchLogin = createAsyncThunk(
  login,
  async (payload, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch,);
    try {
      dispatch(updateLoading(true));
      const response = await API.post(LOGIN, payload);
 
      return response;
    } catch (err) {
      ToastNotifyError(err);
      rollbar.error("Error message", err);
      return err;
    } finally {
      dispatch(updateLoading(false));
    }
  }
);

const fetchLogout = createAsyncThunk(
  logout,
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, {isAuthHeader: true});
    try {
      dispatch(updateLoading(true));
      const response = await API.post(LOGOUT, data);
  
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    } finally {
      dispatch(updateLoading(false));
    }
  }
);
const fetchForgetPassword = createAsyncThunk(
  forget_password,
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch,);
    try {
      dispatch(updateLoading(true));
      const response = await API.post(FORGET_PASSWORD, {email: data?.email?.toLowerCase() || ''});
      
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    } finally {
      dispatch(updateLoading(false));
    }
  }
);
const fetchSignup = createAsyncThunk(
  signup,
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch,);
    try {
      dispatch(updateLoading(true));
      const response = await API.post(SIGNUP, data);
      if (response.status === 201) {
        return response?.data;
      } else {
        return response?.response?.data;
      }
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    } finally {
      dispatch(updateLoading(false));
    }
  }
);

const fetchCitys = createAsyncThunk(
  get_citys,
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch,);
    try {
      dispatch(updateLoading(true));
      const response = await API.get(GET_CITYS);
  
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    } finally {
      dispatch(updateLoading(false));
    }
  }
);

const fetchCountrys = createAsyncThunk(
  get_countrys,
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch,);
    try {
      dispatch(updateLoading(true));
      const response = await API.get(GET_COUNTRYS);
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    } finally {
      dispatch(updateLoading(false));
    }
  }
);

const fetchCitysByCountry = createAsyncThunk(
  get_citys_by_country,
  async (params = {}, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch,);
    try {      
      // Build query parameters
      const queryParams = new URLSearchParams();
      if (params.country) queryParams.append('country', params.country);
      if (params.search) queryParams.append('search', params.search);
      if (params.page_no) queryParams.append('page_no', params.page_no);
      if (params.page_size) queryParams.append('page_size', params.page_size);
      
      const url = queryParams.toString() ? `${GET_CITYS_BY_COUNTRY}?${queryParams.toString()}` : GET_CITYS_BY_COUNTRY;
      const response = await API.get(url);
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    } finally {
      console.log('city loaded')
    }
  }
);

const fetchEmailCheck = createAsyncThunk(
  email_check,
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch,);
    try {
      dispatch(updateLoading(true));
      const response = await API.post(CHECK_EMAIL, data);
    
      return response;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    } finally {
      dispatch(updateLoading(false));
    }
  }
);
const uploadImage = createAsyncThunk(
  "auth/upload-Image",
  async (binaryData, { dispatch, getState }) => {
    const APIWithAuth = getAuthorization(getState, dispatch, { isAuthHeader: true, deviceType: false });

    try {
      dispatch(updateLoading(true));
      const preSignedResponse = await APIWithAuth.post(PRE_SIGNED_URL);
      const { status } = preSignedResponse?.data;
      const { key, upload_url } = preSignedResponse?.data?.data;

      let uploadResponse = null;

      if (status) {
        const APIWithoutAuth = getAuthorization(getState, dispatch, { isAuthHeader: false, deviceType: false });
        uploadResponse = await APIWithoutAuth.put(upload_url, binaryData);
      }

   
      return { uploadResponse, key };
    } catch (err) {
      rollbar.error("Error message", err);
      dispatch(updateLoading(false));
      return Promise.reject(err);
    } finally {
      dispatch(updateLoading(false));
    }
  }
);

const fetchStatusColors = createAsyncThunk(
  "Bag/getStatusColors",
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, {
      isAuthHeader: true,
      isSessionKey: true,
    });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(STATUS_SELLER_COLOR);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      dispatch(updateLoading(false));
      throw err;
    }
  }
);

const fetchTermsAndCondition = createAsyncThunk(
  "auth/terms-and-condition",
  async (query, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch,);
    try {
      dispatch(updateLoading(true));
      const response = await API.get( TERMS_AND_CONDITION + query);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      dispatch(updateLoading(false));
      throw err;
    }
  }
);

const fetchPrivacyPolicy = createAsyncThunk(
  "auth/privacy-policy",
  async (query, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch,);
    try {
      dispatch(updateLoading(true));
      const response = await API.get( PRIVACY_POLICY + query);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      dispatch(updateLoading(false));
      throw err;
    }
  }
);

const fetchSupportInformation = createAsyncThunk(
  "home/customerSupport",
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(CUSTOMER_SUPPORT);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    }
  }
);

const fetchFaq = createAsyncThunk(
  "home/faq",
  async (searchTerm, { dispatch, getState }) => {
    const API = getAuthorization(getState, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(FAQ + `?search=${searchTerm}`);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

const fetchResetPassword = createAsyncThunk(
  "reset_password",
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch,);
    try {
      dispatch(updateLoading(true));
      const response = await API.post(RESET_PASSWORD, data);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      return err;
    }
  }
);
const fetchResetLinkCheck = createAsyncThunk(
  "reset_link_check",
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch,);
    try {
      dispatch(updateLoading(true));
      const response = await API.post(RESET_LINK_CHECK, data);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

const fetchNewsletter = createAsyncThunk(
  "newsletter",
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch,);
    try {
      dispatch(updateLoading(true));
      const response = await API.post(NEWSLETTER, data);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      return err;
    }
  }
);


export {
  fetchLogin,
  fetchLogout,
  fetchForgetPassword,
  fetchSignup,
  fetchResetLinkCheck,
  uploadImage,
  fetchCitys,
  fetchEmailCheck,
  fetchStatusColors,
  fetchTermsAndCondition,
  fetchPrivacyPolicy,
  fetchSupportInformation,
  fetchResetPassword,
  fetchCountrys,
  fetchCitysByCountry,
  fetchFaq,
  fetchNewsletter
};
